import { render, staticRenderFns } from "./TicketsDetail.vue?vue&type=template&id=32cdc846&"
import script from "./TicketsDetail.vue?vue&type=script&lang=js&"
export * from "./TicketsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports